// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-component .theme {
  display: flex;
  justify-content: center;
}
.theme-component .add-button Button {
  color: #fff;
  background: #2b2b81;
  margin: 10px 50px;
  padding: 10px 15px;
  font-weight: 550;
  border-radius: 10px;
}
.theme-component .theme {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/pages/Theme/ShowTheme/theme.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;AAAJ;AAII;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAJJ","sourcesContent":[".theme-component{\n  .theme{\n    display: flex;\n    justify-content: center;\n  }\n  \n  .add-button{\n    Button{\n      color:  #fff;\n      background: #2b2b81;\n      margin: 10px 50px;\n      padding: 10px 15px;\n      font-weight: 550;\n      border-radius: 10px;\n    }\n  }\n\n  .theme{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
